<script>
    import { afterUpdate } from "svelte";
    import { push } from "svelte-spa-router";

    afterUpdate(() => {
        alert("404 Not Found");
        push("/");
    });
</script>
